














































import { Component, Vue, Watch } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';

import authService from '@/services/auth-services';
import commonService from '@/services/common-services';

import Rating from '@/shared/components/Rating.vue';

@Component({
    components: {
        'rate': Rating
    }
})
export default class LeftMenu extends Vue {
    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDetail() {
        return (this.customerLevels || []).find((cl) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    private async created() {
        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
    }

    @Watch('userInfo', { immediate: true, deep: true })
    private async getCustomersInfo(newVal: any, oldVal: any) {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }
    
}
